import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute';
import StudentLayout from '../components/StudentLayout';
import { ThemeSettingsProvider } from '../context/ThemeSettingsContext';
import Dashboard from '../pages/Dashboard';
import Assignments from '../pages/Assignments';
import Attendance from '../pages/Attendance';
import Certificates from '../pages/Certificates';
import Profile from '../pages/Profile';

// Mount this once inside your app's top-level <Routes> (or render it directly
// if the student panel is the only thing on this branch of the router):
//
//   import StudentRoutes from './routes/StudentRoutes';
//   <Route path="/student/*" element={<StudentRoutes />} />
//
// New pages later (Fees, Exams, Timetable...) just need a new <Route> here
// plus an entry in StudentLayout's navItems array.
const StudentRoutes = () => (
  <ThemeSettingsProvider>
    <Routes>
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <StudentLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="assignments" element={<Assignments />} />
        <Route path="attendance" element={<Attendance />} />
        <Route path="certificates" element={<Certificates />} />
        <Route path="profile" element={<Profile />} />
      </Route>
    </Routes>
  </ThemeSettingsProvider>
);

export default StudentRoutes;
